import { FormattedMessage } from 'react-intl';

import type {
  FilterSeparator,
  FilterWidget,
} from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import { RefinePrice } from './RangeSlider/index.tsx';
import { RefineBundledSale, RefineRarity } from './RefineList/index.tsx';
import { RefineSettlementWallets } from './RefineSettlementWallets/index.tsx';
import { WatchlistFilter } from './WatchlistFilter/index.tsx';

export const RarityGroup = {
  slug: 'rarity',
  filters: [RefineRarity],
};

export const PriceGroup = {
  slug: 'price',
  filters: [RefinePrice({ startsOpen: true })],
};

export const SaleGroup = {
  slug: 'sale',
  title: <FormattedMessage defaultMessage="Sale" />,
  filters: [RefineBundledSale],
};

export const AcceptedCurrencyGroup = {
  slug: 'accepted-currency',
  title: <FormattedMessage defaultMessage="Sale" />,
  filters: [RefineSettlementWallets],
};
export const CollectibleGroup = (f: (FilterWidget | FilterSeparator)[]) => ({
  slug: 'collectibles',
  title: <FormattedMessage defaultMessage="Collectibles" />,
  filters: f,
});

export const WatchlistGroup = {
  slug: 'watchlist',
  title: <FormattedMessage {...filters.watchlist} />,
  filters: [WatchlistFilter],
};
